import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

// actions
import { ingresarAction } from '../../../application/actions/ingresar';
import { transaccionAction } from '../../../application/actions/transaccion';

// componetns
import ConfirmacionTemplate from '../../components/templates/Confirmacion';

const ConfirmacionContainer = () => {


  const dispatch = useDispatch();
  const storeData = useSelector((store) => store.entities.ingresarReducer);
  const storeDataTransaccion = useSelector((store) => store.entities.transaccionReducer.response);
  const loaderData = useSelector((store) => store.ui.loaders.isLoaderGeneralApp);

  const history = useHistory();



  let trackIdParams = new URLSearchParams(window.location.search).get("trackId") ? new URLSearchParams(window.location.search).get("trackId") : localStorage.getItem("Track-Id");

  localStorage.setItem('Track-Id', trackIdParams);

  const [error, setError] = useState({
    rut: '',
    password: '',
    activarButton: true
  });

  const [state, setState] = useState({
    rut: '',
    password: '',
    mensajeErrorPassword: '',
    tipo: { name: 'password' },
    logo: '',
    saldoInsuficiente: false,
    tarjetaBloqueada: false
  });

  // Validacion rut
  const onChangeHandle = (event) => {
    const validacionContrasena = event.target.value.length < 6 || event.target.value.length > 8 ? 'La clave debe tener entre 6 y 8 caracteres.' : '';
    if (validacionContrasena === '') {
      setError({
        ...error,
        activarButton: false
      })
    } else {
      setError({
        ...error,
        activarButton: true
      })
    }

    setState({
      ...state,
      password: event.target.value,
      mensajeErrorPassword: validacionContrasena
    })
  }

  //Cambio de type input clave
  const changeTipoHandler = () => {
      setState({
        ...state,
        tipo: { name : state.tipo.name === 'text'? 'password': 'text' }
      })
    } 

  //Validamos Contraseña para luego ir al siguiente step
  const onSubmitHandle = () => {
    setError({ password: state.mensajeErrorPassword })

    if (state.mensajeErrorPassword === '' && state.password.length >= 6) {
      const params = {
        'rut': state.rut,
        'password': state.password,
        'trackid': trackIdParams
      }
      dispatch(ingresarAction.fetchingresar(params));
    }

  }

  useEffect(() => {
    const idParams = new URLSearchParams(window.location.search).get("trackId") ? new URLSearchParams(window.location.search).get("trackId") : localStorage.getItem("Track-Id");
    dispatch(transaccionAction.fetchTransaccion(idParams));
  }, [dispatch])


  // Obtenemos respuesta del servicio Usuario

  useEffect(() => {
    const { codigo } = storeData.response;
    if (codigo === "0") {
      history.push('/autorizacion');
    }
    if (codigo >= "1") {
      history.push('/error/confirmacion');
    }
  }, [storeData, history]);

  // function siguienteStep (){
  //   const { codigo, data } = storeDataTransaccion;
  //   if (codigo >= 1)  history.push('/errorAutorizacion');
  //   if (data) setState({ ...state, rut: data.rut, logo: data.logoComercio })
  // }



  useEffect(() => {
    const siguienteStep =() =>{
      const { codigo, data } = storeDataTransaccion;
      if (codigo >= 1)  history.push('/error/autorizacion');
      if (data) setState({ ...state, rut: data.rut, logo: data.logoComercio })
    }
    siguienteStep();
  },[storeDataTransaccion,history]);



  return (
    <>
      <ConfirmacionTemplate
        errorRut={error.rut}
        errorPassword={error.password}
        rut={state.rut}
        password={state.password}
        tipoInput={state.tipo.name}
        onChangeIconInput={changeTipoHandler}
        onChangeButton={error.activarButton}
        onChangeHandle={onChangeHandle}
        onSubmitHandle={onSubmitHandle}
        loading={loaderData}
        logo={state.logo}
      />
    </>
  );
};


export default ConfirmacionContainer;

